import {
    BaseButton,
    SignInButton,
    InvertedButton,
    FunctionButton,
    TriggerButton,
  } from './Button.styles';
  
  export const BUTTON_TYPE_CLASSES = {
    base: 'base',
    signin: 'sign-in',
    inverted: 'inverted',
    function: 'function',
    trigger: 'trigger',
  };
  
  const getButton = (buttonType = BUTTON_TYPE_CLASSES.base) =>
    ({
      [BUTTON_TYPE_CLASSES.base]: BaseButton,
      [BUTTON_TYPE_CLASSES.signin]: SignInButton,
      [BUTTON_TYPE_CLASSES.inverted]: InvertedButton,
      [BUTTON_TYPE_CLASSES.function]: FunctionButton,
      [BUTTON_TYPE_CLASSES.trigger]: TriggerButton,
    }[buttonType]);
  
  const Button = ({ children, buttonType, ...otherProps }) => {
    const CustomButton = getButton(buttonType);
    return <CustomButton {...otherProps}>{children}</CustomButton>;
  };
  
  export default Button;